import { MS_PER_30_DAYS } from "./date";

export const MAX_ITEM_DURATION = MS_PER_30_DAYS

export const DEFAULT_CATEGORY = '/'
